import type { TFunction } from "i18next";

/**
 * Maps the refusal messages Collins (Core) returns on the customer pre-order
 * endpoints to localisation keys. Both the hyphenated and unhyphenated
 * "pre-orders"/"preorders" spellings occur upstream.
 */
const preorderRefusalKeys: Record<string, string> = {
  "this booking is not eligible for pre-orders.": "preorder_unavailable_not_eligible",
  "this booking is not eligible for preorders.": "preorder_unavailable_not_eligible",
  "pre-orders for this booking are now closed.": "preorders_closed",
  "this order cannot be edited.": "preorder_unavailable_order_not_editable",
  "the set number of pre-orders for this booking has been reached. please let us know if you want to increase your party size and we can update this for you.":
    "preorder_unavailable_limit_reached",
};

/**
 * Localise a Collins pre-order refusal reason. The raw message is passed as
 * the `defaultValue`, so unmapped or reworded upstream copy still renders
 * something sensible. Returns null when there is no message.
 */
export const translatePreorderRefusal = (t: TFunction, message: string | null | undefined): string | null => {
  if (!message) return null;
  const key = preorderRefusalKeys[message.trim().toLowerCase()];
  return key ? t(key, { defaultValue: message }) : message;
};
